import { GET } from "../../../helpers/restFunction";

export const GetCompletedProject = async (userId: string) => {
  const path = `/cad/users/${userId}/jobs?job_status=completed`;
  return await GET(path)
    .then((response) => {
      return response[1];
    })
    .catch((err: any) => {
      console.log("Error", err);
    });
};
